import { render, staticRenderFns } from "./shift_statistics.vue?vue&type=template&id=978124f0&scoped=true&"
import script from "./shift_statistics.vue?vue&type=script&lang=js&"
export * from "./shift_statistics.vue?vue&type=script&lang=js&"
import style0 from "./shift_statistics.vue?vue&type=style&index=0&id=978124f0&scoped=scoped&lang=scss&"
import style1 from "./shift_statistics.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978124f0",
  null
  
)

export default component.exports